import { DefaultPageLayout } from 'modules/page';
import styled from 'styled-components';

import RequestForm from '../../containers/RequestForm';

export const Root = styled.div``;

export const CardWrp = styled.div`
    height: 100%;
    width: 100%;
    min-width: 960px;
    background: #fff;
    overflow: auto;
`;

export const StyledRequestForm = styled(RequestForm)`
    height: 100%;
    width: 100%;
`;

export const StyledDefaultPageLayout = styled(DefaultPageLayout)`
    height: 100%;
`;
